<template>
  <v-row>
    <v-col cols="12" sm="12">
      <TitleAndSearch
        :icon="'icon_new_user'"
        :title="'Personas'"
        :showSearch="false"
      />
      <PersonInfo />
    </v-col>
  </v-row>
</template>

<script>
import PersonInfo from '@/components/persons/PersonInfo'
import TitleAndSearch from '@/components/TitleAndSearch.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PersonInfo,
    TitleAndSearch
  },
  computed: {
    ...mapGetters('things', ['getCurrentThing']),
    entity() {
      return this.getCurrentThing
    }
  }
}
</script>

<style lang="scss" scoped>
.view-title {
  color: #0a2463;
}

.entity-plate {
  color: #d81077;
}

.card-subtitle {
  color: #0a2463;
}
</style>
